export default "__VITE_ASSET__DpML_s6m__"